import s from './index.module.css'
import common from '../../common.module.css'
import JsonPars from "@UI/JsonPars/JsonPars";
import classNames from 'classnames';
import { getCorrectFilePath } from '@/helpers/new/getCorrectFilePath';

export const Baskets = (
    {   
        baskets,
        dragOvertHandler,
        dropHandler,
        dragEndHandler,
        addFromCart,
        dragStartHandler,
        setCuttentOptionByClick,
        correctAnswer,
        cuttentOptionByClick,
        isInteractive,
        hideSolutionCorrectness
    }
) => {
    return(
        <div className={s.baskets}>
           {baskets.map((basket)=>{
            let optionsTextBasket = basket.options.filter((el) => el.type === 'text')
            let optionsImgBasket = basket.options.filter((el) => el.type === 'img')
            
            return (
              <div 
                key={basket.id}
                {
                    ...(isInteractive && {
                            onDragOver: dragOvertHandler, //находимся над ним
                            onDrop: (e) => dropHandler(e, basket), //отпустили карточку и рассчитываем что должно произойти какое то связанное с этим действие
                            onDragLeave: dragEndHandler, //вышли за перделы другой карточки
            
                            onClick: (e)=>{
                                if(!e.target.classList.contains(s.optionBasket)){
                                    addFromCart(basket.id)
                                }
                            }
                        }
                    )
                }

                className={s.basket}>
                  <div className={common.title}>{basket.name}</div>
                  <div className={classNames(common.options, s.optionsBasket)}>
                    {
                      optionsTextBasket.map((option) => {
                        return (
                          <button
                            key={option.id}
                            {
                                ...(isInteractive && {
                                        onDragStart: (e) => dragStartHandler(e, option, basket), //взяли карточку
                                        onDragEnd: (e) => dragEndHandler(e), //отпустили перемещение картички
                                        onClick: () => {
                                            setCuttentOptionByClick(option)
                                        }  
                                    }
                                )
                            }
                            draggable={isInteractive} //сделали передвигаемой
                            
                            className={
                              classNames(
                                s.optionBasket, 
                                {[common.optionCurrent]: cuttentOptionByClick && cuttentOptionByClick.id == option.id},
                                {[s.optionWrong]: correctAnswer && !correctAnswer[basket.id].includes(Number(option.id)) && !hideSolutionCorrectness},
                                {[s.optionCorrectly]: correctAnswer && !!correctAnswer[basket.id].includes(Number(option.id))},
                              )
                            }
                          >
                              <JsonPars json={option.text} />
                          </button>
                        )
                      })
                    }

                    {
                      !!optionsTextBasket.length && <div style={{width:'100%', height:'1px', background: 'none'}}></div>
                    }
                    
                    {
                      optionsImgBasket.map((option) => {
                        return (
                          <button
                            key={option.id}
                            {
                                ...(isInteractive && {
                                        onDragStart: (e) => dragStartHandler(e, option, basket), //взяли карточку
                                        onDragEnd: (e) => dragEndHandler(e), //отпустили перемещение картички
                                        onClick: ()=> {
                                            setCuttentOptionByClick(option)
                                        }
                                    }
                                )
                            }
                            draggable={isInteractive} //сделали передвигаемой
                            
                            className={classNames(
                                          s.optionBasket, 
                                          common.optionImg, 
                                          s.basketOptionImg, 
                                          {[common.optionCurrent]: cuttentOptionByClick && cuttentOptionByClick.id == option.id},
                                          {[s.optionWrong]: correctAnswer && !correctAnswer[basket.id].includes(Number(option.id))},
                                          {[s.optionCorrectly]: correctAnswer && !!correctAnswer[basket.id].includes(Number(option.id))},
                                        )
                                      }>
                              <img alt='Изображение' src={getCorrectFilePath(option?.img)} />
                          </button>
                        )
                      })
                    }
                  </div>
              </div>
            )
           })}  
        </div>
    )
}